module.exports = "Une fois que *{{customerName}}* se sera connecté sur Follo, il aura accès à ses chiffres"


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/campaigns/i18n/markdown/fr/custumerName.md
// module id = ./src/statsradio/modules/campaigns/i18n/markdown/fr/custumerName.md
// module chunks = 18